import React, { useEffect, useState } from 'react';
import HomeLayout from '../Layouts/homeLayout';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import CreateNewUser from './components/add';
import { getusersList, createUser, addPlan, deleteUser, updateUser, getActiveCustomPlans } from './../../actions/userActions';
import LoadingView from '../Loader/LoadingView';
import { toast } from 'react-toastify';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddUserPlan from './components/addPlan';
import ConfirmAlert from '../common/confirmAlert';
// import { confirmAlert } from 'react-confirm-alert';
// import 'react-confirm-alert/src/react-confirm-alert.css';
import { styled } from '@mui/material/styles';
import './styles.css';

let plans = {
	'customerPlanA' : 'Personal Conference Room for $6/month',
	'customerPlanB' : 'Basic Conference Room for $11/month',
	'customerPlanC' : 'Basic Pro Conference Room for $21/month',
	'customerPlanD' : 'KonX eCard for $41',

	'EnterpriseRoom' : 'Enterprise Conference Room for $81/month',

	'BusinessRoom' : 'Business Conference Room for $26/month',

	'CorporateRoom' : 'Corporate Conference Room for $51/month'

	// 'planA' : '1 KONX PACK FOR $250',

	// 'planB' : '1 KONX PACK FOR $500',

	// 'planC' : '1 KONX PACK FOR $250 AND 1 KONX ECARD PACK FOR $500'
};

let plansListing = {
	'customerPlanA' : 'Personal Conference Room for $6/month',
	'customerPlanB' : 'Basic Conference Room for $11/month',
	'customerPlanC' : 'Basic Pro Conference Room for $21/month',
	'customerPlanD' : 'KonX eCard for $41',

	'EnterpriseRoom' : 'Enterprise Conference Room for $81/month',

	'BusinessRoom' : 'Business Conference Room for $26/month',

	'CorporateRoom' : 'Corporate Conference Room for $51/month',

	'planA' : '1 KONX PACK FOR $250',

	'planB' : '1 KONX PACK FOR $500',

	'planC' : '1 KONX PACK FOR $250 AND 1 KONX ECARD PACK FOR $500'
};

const roles = {
	'TeamAgent'  : 'Team Agent',
	'SalesAgent' : 'Sales Agent',
	'Admin'      : 'Admin',
	'Customer'   : 'Customer'
};

const columns = [
	{ id: 'fname', label: 'Name', minWidth: 170 },
	{ id: 'email', label: 'Email', minWidth: 100 },
	{ id: 'teamName', label: 'Team Name', minWidth: 100 },
	{
		id       : 'licenses',
		label    : 'Package/Plan',
		minWidth : 170,
		format   : (value) => formatPlanWithCount(value)
	},
	{ id       : 'userType',
		label    : 'User Type',
		minWidth : 100,
		format   : (value) => (roles[value] ? roles[value] : 'No Role') }
];

function formatPlanWithCount(value)
{
	if (!value || value.length === 0)
	{

		return 'No Package';
	}

	// Group value.licenses by plan
	const planCountMap = value?.reduce((acc, license) =>
	{
		const planName = getPlanName(license.planId);

		if (!planName) return acc; // Skip if no plan found

		if (acc[planName])
		{
			acc[planName] += 1; // Increment count if the plan exists
		}
		else
		{
			acc[planName] = 1; // Initialize with count 1 if it's the first occurrence
		}

		return acc;
	}, {});

	// Create a formatted string with plan names and counts
	return Object.entries(planCountMap)
		.map(([ planName, count ]) => (count > 1 ? `${planName} (${count})` : planName))
		.join(', ');
}

// Function to get the plan name from planId
function getPlanName(planId)
{
	return plansListing[planId] || null;
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`] : {
		backgroundColor : theme.palette.common.black,
		color           : theme.palette.common.white
	},
	[`&.${tableCellClasses.body}`] : {
		fontSize : 14
	}
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	'&:nth-of-type(odd)' : {
		backgroundColor : theme.palette.action.hover
	},
	// hide last border
	'&:last-child td, &:last-child th' : {
		border : 0
	}
}));

const UsersList = () =>
{
	const [ openNew, setOpenNew ] = useState(false);
	const [ openPlans, setOpenPlan ] = useState(null);
	const [ menuOpen, setMenuOpen ] = useState(null);
	const [ deleteId, setDeleteId ] = useState(null);
	const [ editData, setEditData ] = useState(null);
	const [ page, setPage ] = React.useState(0);
	const [ rowsPerPage, setRowsPerPage ] = React.useState(10);
	const [ data, setData ] = useState({ loading: false, count: 0, list: [] });
	const [ anchorEl, setAnchorEl ] = React.useState(null);
	const [ search, setSearch ] = useState('');
	const [ combinedPlans, setCombinedPlans ] = useState({ ...plans });

	const handleChangePage = (event, newPage) =>
	{
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) =>
	{
		setRowsPerPage(Number(event.target.value));
		setPage(0);
	};

	const getData = (searchKey = '') =>
	{
		setData((prevState) => { return { ...prevState, loading: true }; });
		getusersList(page, rowsPerPage, searchKey).then((res) =>
		{
			// eslint-disable-next-line quotes, no-console
			// console.log("res ==== ", res);
			if (res?.data?.success)
			{
				setData({ loading: false, count: res.data.count, list: [ ...res.data.data ] });
			}
			else
			{
				setData({ loading: false, count: 0, list: [] });
			}
		})
			.catch((err) =>
			{
				// eslint-disable-next-line quotes, no-console
				console.log("err ==== ", err);
				setData({ loading: false, count: 0, list: [] });
			});
	};

	useEffect(() =>
	{
		const loadData = setTimeout(() =>
		{
			getData(search);
		}, 500);

		return () => clearTimeout(loadData);
	}, [ page, rowsPerPage, search ]);

	useEffect(() =>
	{
		getActiveCustomPlans().then((res) =>
		{
			if (res?.data?.status)
			{
				const customPlans = res.data.data.reduce((acc, item) =>
				{
					acc[item._id] = item.title;

					return acc;
				}, {});

				plans = { ...combinedPlans, ...customPlans };
				plansListing = { ...plansListing, ...customPlans };
				setCombinedPlans((prev) => ({ ...prev, ...customPlans }));
			}
		})
			.catch((err) =>
			{
				// eslint-disable-next-line no-console
				console.log('err ==== ', err);
			});
	}, []);

	const handleClose = () =>
	{
		setOpenNew(false);
		setEditData(null);
	};

	const handleSave = (body) =>
	{
		// eslint-disable-next-line quotes, no-console
		// console.log("body ==== ", body);
		setData((prevState) => { return { ...prevState, loading: true }; });
		createUser(body).then((res) =>
		{
			if (res?.data?.success)
			{
				toast.success('Created successfully');
				setOpenNew(false);
				setPage(0);
				getData();
			}
			else
			{
				setData((prevState) => { return { ...prevState, loading: false }; });
				toast.error(res.data.msg);
			}
		})
			.catch((err) =>
			{
				// eslint-disable-next-line quotes, no-console
				console.log('err === ', err);
				setData((prevState) => { return { ...prevState, loading: false }; });
				toast.error('Internal server error, Please try again');
			});
	};

	const handleUpdate = (uid, body) =>
	{
		// eslint-disable-next-line quotes, no-console
		// console.log("body ==== ", body);
		setData((prevState) => { return { ...prevState, loading: true }; });
		updateUser(uid, body).then((res) =>
		{
			if (res?.data?.success)
			{
				toast.success('Updated successfully');
				setEditData(null);
				setPage(0);
				getData();
			}
			else
			{
				setData((prevState) => { return { ...prevState, loading: false }; });
				toast.error(res.data.msg);
			}
		})
			.catch((err) =>
			{
				// eslint-disable-next-line quotes, no-console
				console.log('err === ', err);
				setData((prevState) => { return { ...prevState, loading: false }; });
				toast.error('Internal server error, Please try again');
			});
	};

	const handleUserMenu = (event, id) =>
	{
		setMenuOpen(id);
		setAnchorEl(event.currentTarget);
	};

	const handleMenuClose = () =>
	{
		setMenuOpen(null);
		setAnchorEl(null);
	};

	const handlePlan = (rowData) =>
	{
		setOpenPlan({ ...rowData });
		handleMenuClose();
	};

	const handleDelete = (id) =>
	{
		setDeleteId(id);
		handleMenuClose();
	};

	const handleEdit = (userObj) =>
	{
		setEditData(userObj);
		handleMenuClose();
	};

	const handlePlanClose = () =>
	{
		setOpenPlan(null);
	};

	const handleAddPlan = (body) =>
	{
		addPlan(body).then((res) =>
		{
			if (res?.data?.success)
			{
				toast.success('Package added successfully');
				setOpenPlan(null);
				setPage(0);
				getData();
			}
			else
			{
				setData((prevState) => { return { ...prevState, loading: false }; });
				toast.error(res.data.msg);
			}
		})
			.catch((err) =>
			{
				// eslint-disable-next-line quotes, no-console
				console.log('err === ', err);
				setData((prevState) => { return { ...prevState, loading: false }; });
				toast.error('Internal server error, Please try again');
			});
	};

	const handleDeleteUser = () =>
	{
		deleteUser({ userId: deleteId }).then((res) =>
		{
			if (res?.data?.success)
			{
				toast.success('Deleted successfully');
				setPage(0);
				setDeleteId(null);
				getData();
			}
			else
			{
				setData((prevState) => { return { ...prevState, loading: false }; });
				toast.error(res.data.msg);
			}
		})
			.catch((err) =>
			{
				// eslint-disable-next-line quotes, no-console
				console.log('err === ', err);
				setData((prevState) => { return { ...prevState, loading: false }; });
				toast.error('Internal server error, Please try again');
			});
	};

	// eslint-disable-next-line quotes, no-console
	// console.log("data ==== ", data);

	return (
		<div className='flexCol pdngSM fullHeight'>
			<div className='users-top-bar'>
				<div className='search-section'>
					<input id='search' type='search' placeholder='Search...' onChange={(e) => setSearch(e.target.value)}/>
				</div>
				<div className='button-section'>
					<Button
						variant='contained'
						size='small'
						title='Create User'
						onClick={() => setOpenNew(true)}
					>Create User</Button>
				</div>
			</div>
			{data?.loading && <LoadingView />}
			<Paper sx={{ width: '100%', overflow: 'hidden' }}>
				<TableContainer sx={{ maxHeight: 440 }}>
					<Table stickyHeader aria-label='sticky table'>
						<TableHead>
							<TableRow>
								{columns.map((column) => (
									<StyledTableCell
										key={column.id}
										align={column.align}
										style={{ minWidth: column.minWidth }}
									>
										{column.label}
									</StyledTableCell>
								))}
								<StyledTableCell />
							</TableRow>
						</TableHead>
						<TableBody>
							{data.list.map((row) =>
								(<StyledTableRow hover role='checkbox' tabIndex={-1} key={row._id}>
									{columns.map((column) =>
									{
										const value = row[column.id];

										return (
											<StyledTableCell key={column.id} align={column.align}>
												{column.format
													? column.format(value)
													: value}
											</StyledTableCell>
										);
									}
									)}
									<StyledTableCell>
										<IconButton
											aria-label='more'
											id='long-button'
											aria-controls={menuOpen !== null ? 'long-menu' : undefined}
											aria-expanded={menuOpen !== null ? 'true' : undefined}
											aria-haspopup='true'
											onClick={(e) => handleUserMenu(e, row._id)}
										>
											<MoreVertIcon />
										</IconButton>
										<Menu
											id='long-menu'
											MenuListProps={{
												'aria-labelledby' : 'long-button'
											}}
											anchorEl={anchorEl}
											open={menuOpen === row._id}
											onClose={handleMenuClose}
											// PaperProps={{
											// 	style : {
											// 		maxHeight : ITEM_HEIGHT * 4.5,
											// 		width     : '20ch'
											// 	}
											// }}
										>
											<MenuItem onClick={() => handlePlan(row)}>
												Add Package
											</MenuItem>
											<MenuItem onClick={() => handleEdit(row)}>
												Edit
											</MenuItem>
											<MenuItem onClick={() => handleDelete(row._id)}>
												Delete
											</MenuItem>
										</Menu>
									</StyledTableCell>
								</StyledTableRow>)
							)}
						</TableBody>
					</Table>
				</TableContainer>
				<TablePagination
					rowsPerPageOptions={[ 10, 25, 100 ]}
					component='div'
					count={data.count}
					rowsPerPage={rowsPerPage}
					page={page}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
				/>
			</Paper>
			{(openNew || editData !== null) &&
			<CreateNewUser
				open={openNew || editData !== null}
				handleClose={handleClose}
				handleSave={handleSave}
				data={editData}
				handleUpdate={handleUpdate}
			/>
			}
			{openPlans !== null &&
			<AddUserPlan
				open={openPlans !== null}
				userData={openPlans}
				handleClose={handlePlanClose}
				handleSave={handleAddPlan}
				userType={openPlans?.userType}
				plans={combinedPlans}
			/>
			}
			{deleteId !== null &&
			<ConfirmAlert
				open={deleteId !== null}
				content='Do you really want to delete the user?'
				handleOk={handleDeleteUser}
				handleCancel={() => setDeleteId(null)}
			/>
			}
		</div>
	);
};

export default HomeLayout(UsersList);